const getUniqueStrings = <T extends string>(list: T[]): T[] => {
  return list.filter((value, index, self) => self.indexOf(value) === index);
};

export default getUniqueStrings;
